import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import '../shared/SimpleTable.less';

function getNonEmptyHeadingTagsList(tagList?: string[]) {
    if (tagList) {
        return tagList.filter((tag) => tag !== '');
    }
    return [];
}

export default function HeadingTagsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                <div className="description-meta">
                    <HeadingTagsResult
                        h1List={result.h1_list}
                        h2List={result.h2_list}
                    />
                </div>

                {result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type HeadingTagsResultProps = {
    h1List?: string[];
    h2List?: string[];
};

function HeadingTagsResult({ h1List, h2List }: HeadingTagsResultProps) {
    const h1TagsList = getNonEmptyHeadingTagsList(h1List);
    const h2TagsList = getNonEmptyHeadingTagsList(h2List);

    return (
        <div className="table-wrapper">
            {h1TagsList.length > 0 && (
                <TagsTable
                    tableTitle="H1 tags"
                    tagList={h1TagsList}
                />
            )}
            {h2TagsList.length > 0 && (
                <TagsTable
                    tableTitle="H2 tags"
                    tagList={h2TagsList}
                />
            )}
        </div>
    );
}

function TagsTable({ tableTitle, tagList }: { tableTitle: string; tagList: string[] }) {
    return (
        <div className="simple-table">
            <div className="simple-table-row header">{tableTitle}</div>
            {tagList.map((item, idx) => (
                <div
                    className="simple-table-row"
                    key={idx}
                >
                    {item}
                </div>
            ))}
        </div>
    );
}
